interface Props {
  children: React.ReactNode;
  type?: 'button' | 'submit';
  disabled?: boolean;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'danger' | 'solid';
  className?: string;
}

const baseClassName =
  'inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-60';

const variantClassNames: Record<NonNullable<Props['variant']>, string> = {
  primary:
    'bg-gradient-to-r from-brand-600 to-accent-500 text-white shadow-lg shadow-brand-200/60 hover:from-brand-500 hover:to-accent-400 focus:outline-none focus:ring-2 focus:ring-brand-300',
  secondary: 'border border-slate-200 bg-white/80 text-slate-600 hover:border-slate-300 hover:text-slate-800',
  danger: 'bg-rose-600 text-white shadow-lg shadow-rose-200/60 hover:bg-rose-500',
  solid: 'bg-brand-900 text-white shadow-lg shadow-brand-200/60 hover:bg-brand-800',
};

export default function ModalButton({
  children,
  type = 'button',
  disabled = false,
  onClick,
  variant = 'primary',
  className = '',
}: Props) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`${baseClassName} ${variantClassNames[variant]} ${className}`.trim()}
    >
      {children}
    </button>
  );
}
